// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "contact_preference.proto" (syntax proto3)
// tslint:disable
import { ContactPreferenceService } from "./contact_preference";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service ContactPreferenceService
 */
export class ContactPreferenceServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = ContactPreferenceService.typeName;
        this.methods = ContactPreferenceService.methods;
        this.options = ContactPreferenceService.options;
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGet
     */
    batchGet(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
